import { useEffect, useState } from 'react';
import { NavLink } from 'react-router';
import { Can } from '@iq/react-components';
import config from '../../config';
import { capitalize } from '../../utils';
import './ApiDocsView.scss';

const ApiDocumentOverView = () => {
  const [apiServiceNames, setApiServiceNames] = useState([]);
  const { services } = config;

  useEffect(() => {
    if (services) {
      const serviceNames = Object.keys(services);
      setApiServiceNames(serviceNames);
    }
  }, [services]);

  return (
    <div className="docs-component">
      <div className="item-group">
        {apiServiceNames?.map((serviceName) => (
          <Can
            key={serviceName}
            permission={`${serviceName}Docs/Read`}
          >
            <div key={serviceName}>
              <NavLink
                title={`${capitalize(serviceName)} service`}
                to={{
                  pathname: `/api-docs/${serviceName}-service`,
                  search: globalThis.location.search,
                }}
              >
                <div className="item">
                  <div className="item--header">
                    <div className="item--text">{capitalize(serviceName)} service</div>
                  </div>
                  <div className="item--description">
                    <p>API docs for {serviceName} service</p>
                  </div>
                </div>
              </NavLink>
            </div>
          </Can>
        ))}
      </div>
    </div>
  );
};

export default ApiDocumentOverView;
